export default "__VITE_ASSET__BrOys3Ma__"